const { platformSwitch } = require('@certilogo/design-system/dist/configuration');
const web = require('./web');
const native = require('./native');

const { getLocale } = platformSwitch({
  web,
  native,
});

exports.getLocale = getLocale;
